import * as Yup from 'yup';

export const businessInfoValidationSchema = Yup.object().shape({
    businessName: Yup.string().required('Business name is required'),
    phone: Yup.string().required('Phone number is required'),
    ownerName: Yup.string().required('Owner name is required'),
    businessEmail: Yup.string().email('Invalid email address').required('Email is required'),
    address: Yup.object().shape({
        line1: Yup.string().required('Address line 1 is required'),
        city: Yup.string().required('City is required'),
        state: Yup.string().required('State is required'),
        country: Yup.string().required('Country is required'),
        zipCode: Yup.string().required('Zip code is required'),
    }),
});
